import React from 'react';
import { Fragment } from 'react';
import Header from '../../components/header'
import Footer from '../../components/footer';
import Atricon from '../../components/atricon';
import Head from '../../components/head';


function AtriconScreen () {
    return (
        <Fragment>
            <Head titulo="Lista de tópicos da ATRICON" />
            <Header />
            <Atricon />
            <Footer />
        </Fragment>
    );
}

export default AtriconScreen;